import React from 'react';

function Banner() {
    return (
        <section id="call-to-action">
            <div className="container wow fadeIn">
                <div className="row">
                    <div className="col-lg-9 text-center text-lg-left">
                        <h3 className="cta-title">Departamento de Engenharia Química da FEUP</h3>
                        <p className="cta-text">Visite também a página do nosso departamento</p>
                    </div>
                    <div className="col-lg-3 cta-btn-container text-center">
                        <a className="cta-btn align-middle" href="https://deq.fe.up.pt/">Visitar website</a>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Banner;